/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ displayName: NonNullable<unknown> }} Brave_Browser_Required_MessageInputs */

const en_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In order to use ${i?.displayName}, you'll have to use Brave Browser. Need to install Brave Browser?`)
};

const id_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Untuk menggunakan ${i?.displayName}, Anda harus menggunakan Brave Browser. Perlu menginstal Brave Browser?`)
};

const ms_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Untuk menggunakan ${i?.displayName}, anda perlu mengguna Brave Browser. Perlu memasang Brave Browser?`)
};

const ca_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Per poder fer servir ${i?.displayName}, hauràs d'utilitzar el navegador de Brave. Necessites instal·lar el navegador de Brave?`)
};

const cs_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chcete-li používat ${i?.displayName}, musíte použít prohlížeč Brave Browser. Potřebujete si prohlížeč Brave Browser nainstalovat?`)
};

const da_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`For at kunne bruge ${i?.displayName} skal du bruge Brave Browser. Har du brug for at installere Brave Browser?`)
};

const de_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Um ${i?.displayName} nutzen zu können, benötigst du den Brave Browser. Möchtest du den Brave Browser installieren?`)
};

const et_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selleks, et kasutada teenust ${i?.displayName}, peate kasutama Brave'i brauserit. Kas installime Brave'i brauseri?`)
};

const es_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Para usar ${i?.displayName}, tendrás que usar el navegador de Brave. ¿Necesitas instalar el navegador de Brave?`)
};

const fr_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pour utiliser ${i?.displayName}, vous devez utiliser le navigateur Brave. Besoin d’aide pour installer Brave ?`)
};

const hr_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kako biste koristili ${i?.displayName}, morate koristiti preglednik Brave. Trebate instalirati preglednik Brave?`)
};

const it_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Per poter usare ${i?.displayName}, devi usare il browser Brave. Devi installare Brave?`)
};

const lv_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lai izmantotu ${i?.displayName}, jums ir nepieciešams Brave pārlūks. Vai vēlaties to instalēt?`)
};

const lt_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Norint naudoti ${i?.displayName}, reikia naršyklės „Brave“. Ar norite ją įdiegti?`)
};

const hu_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A ${i?.displayName} használatához a Brave böngészőt kell használnia. Telepítenie kell a Brave böngészőt?`)
};

const nl_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Als je ${i?.displayName} wilt gebruiken, moet je de Brave-browser gebruiken. Wil je de Brave-browser installeren?`)
};

const nb_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName} er bare tilgjengelig i Braves nettleser. Vil du installere Braves nettleser?`)
};

const pl_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aby móc korzystać z ${i?.displayName}, musisz używać przeglądarki Brave. Czy chcesz zainstalować przeglądarkę Brave?`)
};

const pt_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Para usar o ${i?.displayName}, você terá que usar o navegador Brave. Precisa instalar o navegador Brave?`)
};

const ro_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pentru a putea folosi ${i?.displayName}, va trebui să folosești Brave Browser. Ai nevoie să instalezi Brave Browser?`)
};

const sk_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ak chcete používať ${i?.displayName}, musíte použiť prehliadač Brave. Potrebujete nainštalovať prehliadač Brave?`)
};

const sl_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Če želite uporabljati »${i?.displayName}«, boste morali uporabiti brskalnik Brave. Želite namestiti brskalnik Brave?`)
};

const fi_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sinulla tulee olla Brave Browser, jotta voit käyttää kohdetta ${i?.displayName}. Tarvitseeko sinun asentaa Brave Browser?`)
};

const sv_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`För att kunna använda ${i?.displayName} måste du använda Brave-webbläsaren. Behöver du installera Brave-webbläsaren?`)
};

const vi_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Để sử dụng ${i?.displayName}, bạn cần sử dụng trình duyệt Brave. Cần cài đặt trình duyệt Brave?`)
};

const tr_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName} hesabını kullanmak için Brave Tarayıcı kullanmanız gerekecek. Brave Tarayıcı'yı yüklemeniz mi gerekiyor?`)
};

const el_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Για να χρησιμοποιήσετε το ${i?.displayName}, θα πρέπει να χρησιμοποιήσετε το Brave Browser. Θέλετε να εγκαταστήσετε το Brave Browser;`)
};

const bg_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`За да използваш ${i?.displayName}, ще трябва да използваш браузъра Brave. Налага ли се да инсталираш Brave Браузър?`)
};

const ru_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Для использования ${i?.displayName} вам необходимо использовать Brave Browser. Нужно установить Brave Browser?`)
};

const sr_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Да бисте користили функцију ${i?.displayName}, мораћете да користите Brave прегледач. Треба да инсталирате Brave прегледач?`)
};

const uk_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Для того, щоб користуватися сайтом ${i?.displayName}, вам потрібен браузер Brave. Хочете встановити браузер Brave?`)
};

const ka_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName}-ის გამოსაყენებლად, თქვენ უნდა გამოიყენოთ Brave ბრაუზერი. გჭირდებათ Brave ბრაუზერის ინსტალაცია?`)
};

const hi_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName} का उपयोग करने के लिए, आपको ब्रेव ब्राउज़र का उपयोग करना होगा। क्या आपको ब्रेव ब्राउज़र इंस्टॉल करने की ज़रुरत है?`)
};

const th_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เพื่อใช้ ${i?.displayName} คุณจะต้องใช้ Brave Browser ต้องการติดตั้ง Brave Browser หรือไม่`)
};

const ko_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName}을(를) 사용하려면 Brave 브라우저를 사용해야 합니다. Brave 브라우저를 설치하셔야 하나요?`)
};

const zh_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`如要使用 ${i?.displayName}，您须使用 Brave 浏览器。要安装 Brave 浏览器吗？`)
};

const zh_tw_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`若要使用 ${i?.displayName}，您必須使用 Brave 瀏覽器。需要安裝 Brave 瀏覽器嗎？`)
};

const ja_brave_browser_required_message = /** @type {(inputs: Brave_Browser_Required_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName}を使用するには、Braveブラウザを使用する必要があります。Braveブラウザをインストールする必要がありますか？`)
};

/**
* | output |
* | --- |
* | "In order to use {displayName}, you'll have to use Brave Browser. Need to install Brave Browser?" |
*
* @param {Brave_Browser_Required_MessageInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const brave_browser_required_message = /** @type {((inputs: Brave_Browser_Required_MessageInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brave_Browser_Required_MessageInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_brave_browser_required_message(inputs)
	if (locale === "ms") return ms_brave_browser_required_message(inputs)
	if (locale === "ca") return ca_brave_browser_required_message(inputs)
	if (locale === "cs") return cs_brave_browser_required_message(inputs)
	if (locale === "da") return da_brave_browser_required_message(inputs)
	if (locale === "de") return de_brave_browser_required_message(inputs)
	if (locale === "et") return et_brave_browser_required_message(inputs)
	if (locale === "es") return es_brave_browser_required_message(inputs)
	if (locale === "fr") return fr_brave_browser_required_message(inputs)
	if (locale === "hr") return hr_brave_browser_required_message(inputs)
	if (locale === "it") return it_brave_browser_required_message(inputs)
	if (locale === "lv") return lv_brave_browser_required_message(inputs)
	if (locale === "lt") return lt_brave_browser_required_message(inputs)
	if (locale === "hu") return hu_brave_browser_required_message(inputs)
	if (locale === "nl") return nl_brave_browser_required_message(inputs)
	if (locale === "nb") return nb_brave_browser_required_message(inputs)
	if (locale === "pl") return pl_brave_browser_required_message(inputs)
	if (locale === "pt") return pt_brave_browser_required_message(inputs)
	if (locale === "ro") return ro_brave_browser_required_message(inputs)
	if (locale === "sk") return sk_brave_browser_required_message(inputs)
	if (locale === "sl") return sl_brave_browser_required_message(inputs)
	if (locale === "fi") return fi_brave_browser_required_message(inputs)
	if (locale === "sv") return sv_brave_browser_required_message(inputs)
	if (locale === "vi") return vi_brave_browser_required_message(inputs)
	if (locale === "tr") return tr_brave_browser_required_message(inputs)
	if (locale === "el") return el_brave_browser_required_message(inputs)
	if (locale === "bg") return bg_brave_browser_required_message(inputs)
	if (locale === "ru") return ru_brave_browser_required_message(inputs)
	if (locale === "sr") return sr_brave_browser_required_message(inputs)
	if (locale === "uk") return uk_brave_browser_required_message(inputs)
	if (locale === "ka") return ka_brave_browser_required_message(inputs)
	if (locale === "hi") return hi_brave_browser_required_message(inputs)
	if (locale === "th") return th_brave_browser_required_message(inputs)
	if (locale === "ko") return ko_brave_browser_required_message(inputs)
	if (locale === "zh") return zh_brave_browser_required_message(inputs)
	if (locale === "zh-tw") return zh_tw_brave_browser_required_message(inputs)
	if (locale === "ja") return ja_brave_browser_required_message(inputs)
	return en_brave_browser_required_message(inputs)
});